import React from 'react';

export const columnsProposals = [
  {
    name: <span className="font-weight-bold fs-13">Proposta</span>,
    sortable: true,
    width: '10%',
    selector: (row) => row.number,
  },
  {
    name: <span className="font-weight-bold fs-13">Nome do Associado</span>,
    selector: (row) => row.name,
    width: '20%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">CPF</span>,
    selector: (row) => row.cpf,
    width: '13%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Plano</span>,
    selector: (row) => row.plan,
    width: '15%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Dependentes</span>,
    selector: (row) => row.qty_dependents,
    width: '10%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Valor</span>,
    selector: (row) => row.price,
    width: '10%',
    sortable: true,
  },
  {
    name: <span className="font-weight-bold fs-13">Status</span>,
    sortable: false,
    width: '8%',
    selector: (cell) => {
      return (
        <div>
          <span className={`badge badge-soft-${cell.status_color}`}>
            <i className="mdi mdi-circle-medium"></i> {cell.status}
          </span>
        </div>
      );
    },
  },
];
